import React from "react";
import { Grid } from "@mui/material";
import LoginForm from "../components/LoginForm";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import petcozoolog from "../assets/petcozoolog.png";
import logoAn from "../assets/LogoAn.png";
import AppBar from "@mui/material/AppBar";
import Logo from "../assets/Logo.png";
import { connect } from "react-redux";
import { styles } from "../theme/styles";
import SnackBar from "../components/SnackBarCustom";
import { Creators as CreatorsConfig } from "../store/ducks/config";

const LoginPage = (props) => {
  const { clearMessage, message } = props;
  const { t } = useTranslation();
  return (
    <>
      <div style={styles.backgroundLog}>
        <AppBar
          position="static"
          color="primary"
          enableColorOnDark
          style={styles.head}>
          <img src={Logo} style={styles.logoP} alt="Logo" />
          <img src={logoAn} style={styles.logoAn} alt="Logo" />
        </AppBar>
        <div style={styles.body}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={styles.grid}>
            <Grid item xs={10} sm={6} md={3}>
              <Typography
                variant="h3"
                justifyContent="center"
                color="primary"
                style={styles.title}>
                {t("title")}
              </Typography>
              <LoginForm />
            </Grid>
            <div style={styles.logoContainer}>
              <img
                alt="Company Logo"
                src={petcozoolog}
                style={styles.logo}
                variant="rounded"
              />
            </div>
          </Grid>
        </div>
      </div>
      {message ? (
        <SnackBar
          message={message.text}
          variant={message.type}
          open={message ? true : false}
          onClose={clearMessage}
          time={3000}
        />
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    logged: state.users.logged,
    uid: state.users.uid,
    menu: state.users.menu,
    loading: state.users.loading,
    message: state.config.message,
  };
};

const creators = {
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, creators)(LoginPage);
